import { LIBRARY_DATA, LIBRARY_FILE } from '@/constants/treeConstants';
import { TRACE } from '@/constants/libraryConstants';
import { SPICE, IBIS_AMI, PKG_SPICE, PCB_SPICE, ON_DIE_SPICE, PCB_PDN_SPICE, USER_DEFINED_NETLIST, CUSTOM_POST_PROCESS } from '../../../constants/libraryConstants';

/**
 *
 *
 * @param {*} key
 * @param {*} { name, type, id, fileName } type - file|data
 */
function libraryItem(key, { name, type, id, fileName, typeName, nodeClass, status, folderChildren, deletable, folder, isAmi = false, checkLossFiles = null }) {
  this.name = name;
  this.type = type;
  this.id = id;
  this.dataType = type === 'data' ? LIBRARY_DATA : LIBRARY_FILE;
  this.fileName = fileName;
  this.key = this.id + '-' + this.name;
  this.fileType = key === TRACE ? typeName : key;
  this.nodeClass = nodeClass;
  this.status = status;
  this.deletable = deletable;
  this.folderChildren = folderChildren || false
  this.icon = key === "SPICE" ? type === "folder" ? 'file-folder' : 'file' : null;
  this.folder = folder || '';
  if (this.fileType === IBIS_AMI) {
    this.isAmi = isAmi
    this.checkLossFiles = checkLossFiles
  }
}

/**
 * Get library array
 *
 * @param {String} key IBIS|
 * @param {Array} dataArr [{ id: "", libraryStructure: { name: "", type: "file|data" }, name: "", typeName: "ibis|vector|spice", userId: "" }]
 * @returns [libraryItem]
 */
function getLibraryArray(key, dataArr, oldDataArr) {
  if (!Array.isArray(dataArr) || !dataArr.length) {
    return [];
  }
  const _arr = dataArr.map(item => new libraryItem(key, {
    name: item.libraryStructure ? item.libraryStructure.name : item.name,
    type: item.libraryStructure ? item.libraryStructure.type : 'file',
    id: item.id,
    fileName: item.libraryStructure ? item.libraryStructure.name : item.name,
    typeName: item.typeName ? item.typeName : null,
    nodeClass: 'tree-library-file',
    status: item.libraryStructure ? item.libraryStructure.status : null,
    deletable: item.libraryStructure ? item.libraryStructure.deletable : true,
    checkLossFiles: item.libraryStructure && item.libraryStructure.checkLossFiles && item.libraryStructure.checkLossFiles.length ? ['missing file detected:', ...item.libraryStructure.checkLossFiles] : null
  }));
  return _arr;
}

function getDefaultPatternInfo(name = "", signalGroup) {
  this.name = name;
  let victimSignalGroup = [["DQ", 'DM'], ["ADR", "CMD"]], aggressorSignalGroup = [["DQ", 'DM'], ["ADR", "CMD"], ['DQSP', 'CLKP'], ['DQSN', 'CLKN']];
  if (signalGroup && signalGroup.length) {
    victimSignalGroup = signalGroup;
    aggressorSignalGroup = signalGroup;
  }
  this.Victim = victimSignalGroup.map(item => new defaultVictimAggressorInfo(item));
  this.Aggressor = aggressorSignalGroup.map(item => new defaultVictimAggressorInfo(item));
}

function defaultVictimAggressorInfo(signals = []) {
  this.signals = signals;
  this.pinModels = [];
}

export const LIBRARY_INDEX = 1,
  BUFFER_INDEX = 0,
  VECTOR_INDEX = 1,
  VRM_INDEX = 2,
  PKG_INDEX = 3,
  MASK_INDEX = 4,
  TRACE_INDEX = 5,
  VIA_INDEX = 6,
  SYSTEM_LIBRARY_INDEX = 0,
  SYS_DECAP_INDEX = 0,
  SYS_DECAP_VENDOR_INDEX = 1,
  SYS_DECAP_GENERIC_INDEX = 0,
  SYS_CUSTOM_INDEX = 1;
export const PROJECT_INDEX = 2;


const BUFFERIndex = 0, IBISIndex = 0, IBISAMIIndex = 1, SPICEIndex = 2, vectorIndex = 1, VRMIndex = 2, PACKAGEIndex = 3, EYEMASKINDEX = 4, TRACEINDEX = 5, VIAINDEX = 6, pkgTouchstoneIndex = 0, pkgSPiceIndex = 1, pkgEBDIndex = 2, SOCKET_INDEX = 7,
  CUSTOM_INDEX = 9, WIRE_BOND_INDEX = 10,
  EXTRACTION_OPTIONS_INDEX = 11,
  HFSS_OPTIONS_INDEX = 0,
  SIWAVE_OPTIONS_INDEX = 1,
  PCB_MODEL_INDEX = 12, pcbTouchstoneIndex = 0, pcbSPiceIndex = 1,
  ON_DIE_MODEL_INDEX = 13, onDieTouchstoneIndex = 0, onDieSpiceIndex = 0,
  PDN_MODEL_INDEX = 14, pdnTouchstoneIndex = 0, pdnSpiceIndex = 1,
  DECAP_INDEX = 15, decapTouchstoneIndex = 0, decapSpiceIndex = 1,
  PATTERN_LIBRARY_INDEX = 16, USER_DEFINED_LIBRARY_INDEX = 17, CUSTOM_POST_PROCESS_INDEX = 18;

function getRockyFolderInfo({ spiceList = [], pkgSpiceList = [], pcbSpiceList = [], onDieSpiceList = [], pdnSpiceList = [], userDefinedNetListList = [], ibisAmiList = [], customPostProcessList = [] }) {
  const folderInfo = [{
    list: spiceList,
    libraryType: SPICE,
    index: BUFFERIndex,
    childrenIndex: SPICEIndex,
    key: "spiceList"
  }, {
    list: pkgSpiceList,
    libraryType: PKG_SPICE,
    index: PACKAGEIndex,
    childrenIndex: pkgSPiceIndex,
    key: "pkgSpiceList"
  }, {
    list: pcbSpiceList,
    libraryType: PCB_SPICE,
    index: PCB_MODEL_INDEX,
    childrenIndex: pcbSPiceIndex,
    key: "pcbSpiceList"
  }, {
    list: onDieSpiceList,
    libraryType: ON_DIE_SPICE,
    index: ON_DIE_MODEL_INDEX,
    childrenIndex: onDieSpiceIndex,
    key: "onDieSpiceList"
  }, {
    list: pdnSpiceList,
    libraryType: PCB_PDN_SPICE,
    index: PDN_MODEL_INDEX,
    childrenIndex: pdnSpiceIndex,
    key: "pdnSpiceList"
  }, {
    list: userDefinedNetListList,
    libraryType: USER_DEFINED_NETLIST,
    index: USER_DEFINED_LIBRARY_INDEX,
    key: "userDefinedNetListList"
  }, {
    list: ibisAmiList,
    libraryType: IBIS_AMI,
    index: IBISIndex,
    childrenIndex: IBISAMIIndex,
    key: "ibisAmiList"
  }, {
    list: customPostProcessList,
    libraryType: CUSTOM_POST_PROCESS,
    index: CUSTOM_POST_PROCESS_INDEX,
    key: "customPostProcessList"
  }]
  return folderInfo
}

function getFolderInfoFromType(libraryList, libraryType) {
  const libraryInfo = getRockyFolderInfo({})
  const findInfo = libraryInfo.find(item => item.libraryType === libraryType);
  if (findInfo) {
    return { ...findInfo, list: libraryList }
  }
  return null;
}

export { getLibraryArray, libraryItem, getDefaultPatternInfo, defaultVictimAggressorInfo, getRockyFolderInfo, getFolderInfoFromType };